var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0817 5.94967C5.19364 6.50132 1.49865 10.6346 1.49609 15.5537V16.1659C3.62047 13.6068 6.75615 12.1025 10.0817 12.0472V15.2756C10.0818 15.744 10.3495 16.1711 10.7711 16.3754C11.1926 16.5797 11.6938 16.5251 12.0615 16.235L20.0548 9.92333C20.3386 9.69967 20.5042 9.35827 20.5042 8.99694C20.5042 8.63561 20.3386 8.29421 20.0548 8.07055L12.0615 1.75892C11.6938 1.46875 11.1926 1.4142 10.7711 1.61847C10.3495 1.82274 10.0818 2.24991 10.0817 2.71832V5.94967Z",
    stroke: "#1B382F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgShare;